import { isNotEmpty } from "@mapmycustomers/shared/util/assert";

import FrequencyEntity from "../type/FrequencyEntity";

const hasFrequency = (entity: FrequencyEntity) => isNotEmpty(entity.cadenceInterval);

export default hasFrequency;
